import bidello,{component} from "bidello";

class StateManager extends component(){

    init(){

        this.currentView = null;
        this.previousView = null;
        this.views = []
        this.viewNames = [];
        this.currentState = "";
        this.previousState = "";
        this.pageStates = [];

    }

    registerView (view){

        this.views.push(view);
        this.viewNames.push(view.name);

    }

    setPageStates (pageStates){

        this.pageStates = pageStates;

    }

    getPagesStateByUrl (url,info=""){

        let result = null
        this.pageStates.map((state)=>{

            if(state.url == url){

                result = state;

                if (info && state.info == info){

                    result = state;

                }

            }

        })

        return result;

    }

    getPageStateByInfo (info){

        let result = null
        this.pageStates.map((state)=>{

                if (state.info == info){

                    result = state;

                }


        })

        return result;

    }

    activateView (viewName,state=null){

        this.views.map((view)=>{

            if (view.name == viewName){


                if (view !== this.currentView) {

                    window.app.contentDrawer.close()
                    if (this.previousView)this.previousView.setUnmountState();
                    this.previousView = this.currentView;
                    this.currentView = view;
                    window.app.backdrop.fadeOut().onComplete(()=>{

                        this.currentView.mountView(state);

                        if (this.previousView)this.previousView.unmountView();

                        window.app.backdrop.fadeIn();
                        this.previousView = this.currentView;

                    })


                }



            }

        })

    }

    switchView (){



    }



    addBodyState(state) {

        if (state)document.body.classList.add(state);
        console.log('body state add',state)

    }

    removeBodyState(state) {

        if (state)document.body.classList.remove(state);
        console.log('body state remove',state)


    }

    revertState (){

        return this.previousState

    }


}
export const States = {

    STATE_CHANGE:'stateChange',
    root:{
        PREPARE_STATE:"root_prepare_state",
        DEFAULT_STATE:"root_state",
        EXPLORE_STATE:"explore_state",
        VISIT_STATE:"visit_state",
    },
    observatory:{
        PREPARE_STATE:"observatory_prepare_state",
        DEFAULT_SATE:"observatory_state",
        BUILDING_STATE:"building_state",
        DOME_STATE:"dome_state",
        TELESCOPE_STATE:"telescope_state",
    },
    planetarium:{
        DEFAULT_STATE:"planetarium_state",
        PLANET_STATE:"planet_state",
        PLANET_SELECT_STATE:"planet_select_state",
    },
    contentDrawer:{
        OPEN_STATE:"content_open_state",
        CLOSE_STATE:"content_close_state",
    },
    contactDrawer:{
        OPEN_STATE:"contact_open_state",
        CLOSE_STATE:"contact_close_state",
    },
    filters:{
        OPEN_STATE:"filter_open_state",
        CLOSE_STATE:"filter_close_state",
        TOGGLE_STATE:"filter_toggle_state",
    },
    canvas:{
        OFFSET_CANVAS:"offset_canvas"

    },
    view:{
        VIEW_BACKDROP_FADE:"view_backdrop_fade",
        VIEW_BACKDROP_BLINK:"view_backdrop_blink"
    },
    viewNavigation:{
        DEFAULT:"view_navigation",
        NEXT_STATE:"view_navigation_next_state",
        BACK_STATE:"view_navigation_back_state"

    }
}

export class State {

    constructor (states,url,info){

        this.states = states.split(',');
        this.info = info;
        this.url = url;

        this.data = {}
    }

    getStates (){

        return this.states;

    }

    addState(state){

        this.states.push(state)

    }

    hasState (state){

        return this.states.indexOf(state)>=0;

    }

    getSubState (viewNameState){

        return this.states.splice(this.states.indexOf(viewNameState),1);

    }

    dispatch(){


        this.states.map((state,index)=>{



            stateManager.activateView(state,this);
            if (index == 0) {

                console.log("with url",this.url)
                bidello.trigger({name:States.STATE_CHANGE},{state:state,info:this.info,url:this.url,...this.data})

            } else {

                console.log("with no url",this.url)
                bidello.trigger({name:States.STATE_CHANGE},{state:state,info:this.info,url:"",...this.data})

            }



        })

    }

}

export const stateManager = new StateManager();